<template>
  <div>
    <v-row>
      <v-col cols="12" md="12" lg="12" sm="12">
        <v-expansion-panels
          flat
          focusable
          v-model="defaultPanel"
          style="border: solid 1px #e4e4e4"
        >
          <v-expansion-panel>
            <v-expansion-panel-header
              class="py-0"
              @click="handleExpension"
              disable-icon-rotate
              style="min-height: 50px"
              :color="isOpen ? '#5d58ef' : ''"
              :class="isOpen ? 'white--text' : ''"
            >
              <span>
                <v-icon :color="isOpen ? 'white' : ''">mdi-filter</v-icon>
                Filters
              </span>
              <template v-slot:actions>
                <v-icon :color="isOpen ? 'white' : ''">
                  {{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
                </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="mt-4">
                <v-col cols="12" md="2" lg="2" sm="6" xs="12">
                  <v-autocomplete
                    v-model="type"
                    :items="types"
                    item-text="name"
                    item-value="value"
                    dense
                    hide-details
                    class="ma-2"
                    label="Type"
                  />
                </v-col>
                <v-col cols="12" md="2" lg="2" sm="6" xs="12">
                  <v-combobox
                    class="ma-2"
                    label="Select AMS"
                    v-model="selectedAms"
                    :items="amsArray"
                    dense
                    item-value="id"
                    item-text="name"
                    clearable
                    hide-details
                  />
                </v-col>
                <v-col cols="12" md="2" lg="2" sm="6" xs="12">
                  <v-autocomplete
                    label="Select Priority"
                    class="ma-2"
                    key="priority"
                    v-model="selectedPriority"
                    :items="priorityList"
                    item-text="annotation"
                    item-value="priority"
                    dense
                    clearable
                    hide-details
                  />
                </v-col>
                <v-col cols="12" md="2" lg="2" sm="6" xs="12">
                  <v-combobox
                    class="ma-2"
                    label="Select Center"
                    v-model="selectedFranchisee"
                    :items="franchiseeList"
                    dense
                    item-value="id"
                    item-text="companyName"
                    clearable
                    multiple
                    hide-details
                  >
                    <template v-slot:item="{ item }">
                      <v-icon
                        x-small
                        :color="
                          item.allocated ? 'green darken-3' : 'red darken-3'
                        "
                        >mdi-checkbox-blank-circle</v-icon
                      >
                      <span class="ml-4">{{ item.companyName }}</span>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col
                  v-if="!$vuetify.breakpoint.xs"
                  cols="12"
                  md="4"
                  lg="4"
                  sm="12"
                  xs="12"
                >
                  <v-card-actions class="justify-center">
                    <v-btn
                      color="#5d58ef"
                      class="white--text"
                      small
                      @click="getAmsZoneWiseCalender"
                    >
                      <v-icon left>mdi-filter</v-icon>Apply Filter
                    </v-btn>
                    <v-btn @click="resetFilter" depressed small>
                      <v-icon left> mdi-restart</v-icon> Reset Filter
                    </v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row v-if="$refs.calendar">
      <v-col class="d-flex py-0" cols="12" md="1" lg="1" sm="2" xs="12">
        <v-card class="font-weight-bold caption align-self-end" elevation="0">
          {{ $refs.calendar.title }}
        </v-card>
      </v-col>
      <v-col
        class="d-flex py-0"
        :class="$vuetify.breakpoint.smAndUp ? 'flex-row' : 'flex-column'"
        cols="12"
        md="9"
        lg="9"
        sm="6"
        xs="12"
      >
        <v-card
          v-for="(item, index) in academicManagers"
          :class="$vuetify.breakpoint.smAndUp ? 'ml-4 align-self-end' : ''"
          :key="index"
          elevation="0"
        >
          <v-icon x-small :color="item.color ? item.color : 'green darken-3'"
            >mdi-checkbox-blank-circle</v-icon
          >
          <span class="ml-4">{{ item.amName }}</span>
        </v-card>
      </v-col>
      <v-col class="pa-0" cols="12" md="2" lg="2" sm="4" xs="12">
        <div
          class="d-flex"
          :class="
            $vuetify.breakpoint.smAndUp ? 'justify-end' : 'pl-0 justify-start'
          "
        >
          <v-card class="align-self-end" elevation="0">
            <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn icon class="ma-2" @click="$refs.calendar.next()">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" lg="12" sm="12" xs="12">
        <v-card elevation="0">
          <v-calendar
            ref="calendar"
            class="custom-clander"
            v-model="value"
            :weekdays="weekday"
            :type="type"
            :events="events"
            :event-overlap-mode="mode"
            :event-overlap-threshold="30"
            :event-more="false"
            :event-text-color="getEventTextColor"
            :first-interval="6"
            :interval-minutes="60"
            :interval-count="14"
          >
            <template v-slot:day-label="{ day }">
              <v-btn text fab>
                <span class="subtitle-1">{{ day }}</span>
              </v-btn>
            </template>
            <template v-slot:event="{ event }">
              <v-tooltip
                :min-width="type === 'day' ? '82%' : ''"
                color="grey darken-4"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <div class="pl-2" v-bind="attrs" v-on="on">
                    <v-icon small :color="event.iconColor"
                      >mdi-checkbox-blank-circle</v-icon
                    >
                    <span
                      class="ml-2"
                      v-if="type === 'day'"
                      :class="event.weight"
                      >{{ event.amName }} - {{ event.name }}</span
                    >
                    <span class="ml-2" v-else :class="event.weight">{{
                      event.name
                    }}</span>
                  </div>
                </template>
                <div class="white--text">
                  <p class="py-0 mb-1">{{ event.name }}</p>
                  <p class="py-0 mb-1">{{ event.amName }}</p>
                  <p class="py-0 mb-0">Status: -</p>
                </div>
              </v-tooltip>
            </template>
          </v-calendar>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import constants from '@/utils/constants'
export default {
  name: 'AmsCalenderView',
  props: {
    zoneId: {
      default: 0,
      type: Number
    },
    amsArray: {
      default: () => {},
      type: Array
    },
    franchisee: {
      default: () => {},
      type: Array
    }
  },
  data () {
    return {
      amsList: this.amsArray,
      selectedAms: '',
      franchiseeList: this.franchisee,
      selectedFranchisee: [],
      amsData: [],
      academicManagers: [],
      mode: 'stack',
      type: 'month',
      types: [
        { name: 'Month', value: 'month' },
        { name: 'Week', value: 'week' },
        { name: 'Day', value: 'day' }
      ],
      weekday: [0, 1, 2, 3, 4, 5, 6],
      value: '',
      events: [],
      colors: [
        '#d562f5',
        'purple darken-4',
        'light-green accent-4',
        '#ff3300',
        '#f5e505',
        'green darken-4'
      ],
      copyAcademicManager: [],
      copyAmData: [],
      defaultPanel: 0,
      isOpen: true,
      priorityList: [],
      priorityID: 0,
      selectedPriority: ''
    }
  },
  watch: {
    zoneId: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedAms = ''
        this.selectedFranchisee = []
        this.type = 'month'
        this.getAmsZoneWiseCalender()
      }
    },
    franchisee: function (newVal) {
      this.franchiseeList = newVal
    }
  },
  created () {
    this.getAmsZoneWiseCalender()
    this.getPriorityData()
  },
  methods: {
    handleExpension: function () {
      this.isOpen = !this.isOpen
    },
    getPriorityData: async function () {
      try {
        const res = await http.get(
          `${constants.API_URL}/api/ams/get-priority-annotation`
        )
        if (res.status === 200) {
          res.data.forEach((item) => {
            if (item.annotation === 'H') {
              item.annotation = 'High'
            } else if (item.annotation === 'M') {
              item.annotation = 'Medium'
            } else {
              item.annotation = 'Low'
            }
          })
          this.priorityList = res.data
        } else {
          this.errMsg(res.data.message)
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getAmsZoneWiseCalender: async function () {
      try {
        const events = []
        const franchiseeId = []
        this.academicManagers = []
        this.loadingComponent = this.$buefy.loading.open()
        let payload = {}
        payload.zoneID = parseInt(this.zoneId)
        this.selectedFranchisee.forEach((item) => {
          franchiseeId.push(item.id)
        })
        if (franchiseeId.length > 0) {
          payload.franchiseeId = franchiseeId
        }
        if (this.selectedAms) {
          payload.amId = this.selectedAms.id
        }
        if (this.selectedPriority) {
          console.log(this.selectedPriority)
          payload.priority = this.selectedPriority
        }
        const res = await http.post(
          `${constants.API_URL}/api/ams/get-am-visit-calendar-view`,
          payload
        )
        if (res.status === 200) {
          this.amsData = res.data.amData
          res.data.academicManagers.forEach((item, index) => {
            item.color = this.colors[index]
          })
          this.amsData.forEach((item) => {
            res.data.academicManagers.forEach((am) => {
              let amName = am.amName.split(' ').join('_').toLowerCase()
              if (item[amName] !== 'Available') {
                // events.push({
                //   name: (item[amName] === 'Available') ? `${item[amName]} - ${am.amName}` : item[amName],
                //   weight: (item[amName] === 'Available') ? 'font-weight-medium' : '',
                //   start: new Date(item.date),
                //   iconColor: (item[amName] === 'Available') ? 'lime darken-1' : am.color,
                //   //textColor: (item[amName] === 'Available') ? 'black' : 'white'
                //   textColor: 'black'
                // })
                events.push({
                  name: item[amName],
                  amName: am.amName,
                  weight: 'font-weight-medium',
                  start: new Date(item.date),
                  iconColor: am.color,
                  // textColor: (item[amName] === 'Available') ? 'black' : 'white'
                  textColor: 'black'
                })
              }
            })
          })
          this.academicManagers = res.data.academicManagers
          this.events = events
          this.loadingComponent.close()
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 4000
        })
      }
    },
    // getEventColor (event) {
    //   return event.color
    // },
    getEventTextColor (event) {
      return event.textColor
    },
    resetFilter: function () {
      this.type = 'month'
      this.selectedAms = ''
      this.selectedFranchisee = []
      this.selectedPriority = ''
      this.getAmsZoneWiseCalender()
    }
  }
}
</script>
<style>
.v-calendar-weekly {
  display: table;
  table-layout: fixed;
  height: auto;
  overflow: hidden;
}
.v-calendar-weekly__week {
  height: auto;
  display: table-row;
}
.v-calendar-weekly__day {
  display: table-cell;
  height: 130px;
  width: calc(100% / 7);
}
.v-calendar-weekly__head-weekday {
  min-width: 100%;
  margin-right: 0px !important;
  font-size: 13px;
  font-weight: bold;
}
.custom-clander
  > div.v-calendar-weekly__week
  > div.v-calendar-weekly__day
  > div.v-event {
  background: rgb(0, 0, 0, 0) !important;
}
.custom-clander
  > div.v-calendar-weekly__week
  > div.v-calendar-weekly__day
  > div.primary {
  background: rgb(0, 0, 0, 0) !important;
}
.custom-clander
  > div.v-calendar-daily__head
  > div.v-calendar-daily_head-day
  > div.v-event {
  background: rgb(0, 0, 0, 0) !important;
}
.custom-clander
  > div.v-calendar-daily__head
  > div.v-calendar-daily_head-day
  > div.primary {
  background: rgb(0, 0, 0, 0) !important;
}
</style>
